// The API caps each page at 200 rows. Publish the list only after all pages load.
export default function loadRegistryRequests(api, registryId) {
    var items = [];

    function loadPage(page) {
        return api.getCrmPayoutRequests({
            page: page,
            itemsPerPage: 200,
            filters: { registryId: registryId },
        }).then(function (response) {
            if (!Array.isArray(response.items)) {
                throw new Error("Не удалось загрузить заявки реестра");
            }
            items = items.concat(response.items);
            if (items.length < Number(response.total)) {
                if (response.items.length === 0) {
                    throw new Error("Не удалось загрузить все заявки реестра. Откройте реестр повторно");
                }
                return loadPage(page + 1);
            }
            return items;
        });
    }

    return loadPage(1);
}



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmRegistryModal/loadRegistryRequests.js